var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPopupVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08571 2.5098C8.29714 0.915031 7.18286 4.21128e-07 6 5.24537e-07C4.81714 6.27945e-07 3.70286 0.915031 2.91429 2.5098L0.342856 7.73856C0.257142 7.89542 0.137143 8 0 8L12 8C11.9143 7.97386 11.7086 7.84314 11.6571 7.73856L9.08571 2.5098Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopupVector);
export default __webpack_public_path__ + "static/media/icon-popup-vector.568e1a84d05ea33a95a67c9b962284da.svg";
export { ForwardRef as ReactComponent };